"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxAllocationStatus = exports.InboxDistributionStatus = exports.InboxType = void 0;
exports.InboxType = {
    Distribution: "distribution", // 振り分け
};
exports.InboxDistributionStatus = {
    DistributionRequired: "distributionRequired",
    RobotaLoading: "robotaLoading",
    FileLoading: "fileLoading",
    RobotaLoaded: "robotaLoaded",
    DistributionError: "distributionError",
    ReadError: "readError",
};
// Allocation statuses for file assignment flow (振り分け)
exports.InboxAllocationStatus = {
    WaitingForDept: "waitingForDept",
    WaitingForAssign: "waitingForAssign",
    Unprocessed: "unprocessed",
    Read: "read",
    NoReadRequired: "noReadRequired", // 読取不要
};
